import { createContext } from 'react';

import { ActiveProgressTracker, SyncLogger } from '../SyncLogger';
import { AddError, AddSuccess, SyncedStats, SyncLog } from './SyncingTypes';
export interface ScanSynchronizerContext {
  activeProgressTracker: ActiveProgressTracker;
  isRunning: boolean;
  stats: SyncedStats;
  startSync: (reason?: string) => void;
  stopSync: (reason?: string) => void;
  syncLog: SyncLog[];
  clearSyncStats: () => void;

  /**
   * When true, the user has explicitly paused syncing (e.g., to preserve a flaky connection
   * while finishing a scope). Starts as false. Pausing stops the sync workers between items.
   */
  isPaused: boolean;
  togglePaused: () => void;

  /**
   * For sync workers that live outside this provider (KaiPro's scope-video
   * uploader): they log, report progress, and count successes and errors here,
   * so the Sync UI shows them alongside scan data, photos and notes.
   */
  syncLogger: SyncLogger;
  addSuccess: AddSuccess;
  addError: AddError;

  /**
   * Delete all unsynced data and lose all unsynced data.
   * WARNING: This will delete all unsynced data which will be forever lost. This cannot be undone. (duh!)
   * This is useful to fully reset syncing if it gets into a bad state.
   */
  deleteAndLoseAllUnsyncedData: () => Promise<void>;
}

export const scanSynchronizerContext = createContext<ScanSynchronizerContext | null>(null);
